import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ApiService, URLS } from 'app/services/api.service';

@Component({
  selector: 'app-frame',
  templateUrl: './frame.component.html',
  styleUrls: ['./frame.component.scss']
})
export class FrameComponent implements OnInit {

  public url: string;
  public url1: SafeResourceUrl;
  public exibir : boolean;
  public exibirMenu : boolean;

  @ViewChild('iframe') iframe: ElementRef;

  constructor(private route : ActivatedRoute, private router : Router, private sanitizer: DomSanitizer, private apiService : ApiService) { 
  }
  ngOnInit() {

        this.route.paramMap.subscribe((params : ParamMap) => {
            this.exibir = false;
            this.exibirMenu = false;
            this.url = this.url.replace('api/', '');
            var sistema: string = params.get('sistema');
            var user = JSON.parse(localStorage.getItem("user"));
            var achou : boolean = false;
            if (user != null){
                var acesso = user['acesso'];
                for (let i: number = 0; i < acesso.length; i++){
                    let rota : string = acesso[i]['rotaSistema'];
                    if (rota.replace('/', '') == sistema){
                        achou = true;
                        break;
                    }
                }
                if (achou){
                    let index : string = "index" + sistema.substring(0, 1).toUpperCase() + sistema.substring(1).toLowerCase() + ".php#";
                    this.url = this.url + index + "/" + sistema;

                    this.url1 = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
                    this.exibir = true;
                } else {
                    this.router.navigate(['/search/'+sistema]);
                }
            } else {
                this.router.navigate(['/login']);
            }
        });
        
  }


  
  

}



// WEBPACK FOOTER //
// ./src/app/layouts/frame/frame.component.ts